<template>
  <component
    class="dropdown"
    :is="tag"
    :class="[ { show: isOpen }, { dropdown: direction === 'down' }, { dropup: direction === 'up' } ]"
    aria-haspopup="true"
    :aria-expanded="isOpen"
    @click="toggleDropDown"
    v-click-outside="closeDropDown"
    ref="dropdown"
  >
    <slot name="title">
      <a class="dropdown-toggle nav-link" :class="{ 'no-caret': hideArrow }">
        <i :class="icon"></i>
        <span class="no-icon">{{ title }}</span>
      </a>
    </slot>

    <ul
      class="dropdown-menu"
      ref="menu"
      :class="[ { 'dropdown-menu-right': position === 'right' }, { show: isOpen }, menuClasses ]"
    >
      <slot></slot>
    </ul>
  </component>
</template>

<script>
export default {
  name: "base-dropdown",
  props: {
    direction: { type: String, default: "down" },
    title: String,
    icon: String,
    position: String,
    menuClasses: [String, Object],
    hideArrow: Boolean,
    appendToBody: { type: Boolean, default: false },
    tag: { type: String, default: "li" },
  },
  data() {
    return {
      isOpen: false,
      originalContainer: null,
    };
  },
  watch: {
    isOpen(newVal) {
      if (this.appendToBody) {
        if (newVal) this.appendMenuToBody();
        else this.removeMenuFromBody();
      }
      this.$emit("change", newVal);
    },
  },
  methods: {
    toggleDropDown() { this.isOpen = !this.isOpen; },
    closeDropDown() { this.isOpen = false; },

    appendMenuToBody() {
      const menu = this.$refs.menu;
      if (!menu || menu.parentNode === document.body) return;

      this.originalContainer = menu.parentNode;

      document.body.appendChild(menu);
      menu.style.top = '';
      menu.style.bottom = '';
      menu.classList.add('dropdown-menu-portal', 'show');

      this.updateMenuPosition();

      window.addEventListener('scroll', this.updateMenuPosition);
      window.addEventListener('resize', this.updateMenuPosition);
    },

  removeMenuFromBody() {
    const menu = this.$refs.menu;
    if (menu && menu.parentNode === document.body) {
      menu.classList.remove('dropdown-menu-portal', 'show');

      menu.style.top = '';
      menu.style.bottom = '';
      menu.style.position = '';
      menu.style.left = '';
      menu.style.zIndex = '';

      document.body.removeChild(menu);
    }

    window.removeEventListener('scroll', this.updateMenuPosition);
    window.removeEventListener('resize', this.updateMenuPosition);
  },

  updateMenuPosition() {
    const menu = this.$refs.menu;
    if (!menu || !this.isOpen) return;

    const toggle = this.$el.querySelector('.dropdown-toggle') || this.$el;
    const rect = toggle.getBoundingClientRect();

    menu.style.setProperty('position', 'absolute', 'important');
    menu.style.setProperty('top', `${rect.top + window.scrollY - menu.offsetHeight}px`, 'important');
    menu.style.setProperty('bottom', 'auto', 'important');
    menu.style.setProperty('display', 'block', 'important');
    menu.style.setProperty('margin-right', '20px', 'important');
    menu.style.setProperty('margin-left', '20px', 'important');
    menu.style.setProperty('text-transform', 'uppercase');
    menu.style.setProperty('font-size', '1rem');
    menu.style.setProperty('z-index', '99', 'important');
  }
    },
    mounted() {
      if (this.isOpen && this.appendToBody) this.appendMenuToBody();
    },
    beforeDestroy() {
      if (this.appendToBody) this.removeMenuFromBody();
    },
  };
</script>

<style>
.dropdown {
  list-style-type: none;
}

.dropdown .dropdown-toggle {
  cursor: pointer;
}
</style>
